import * as requestFromServer from "./adsAndAddonsApis";

// update sponsor -> api
export const updateSponsorAction = (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.updateSponsor(dataToBeSent);
    return response
};
